import { z, ZodType } from 'zod';

import { SignInFormData } from '@/components/shared/Modal/content/sign-in/ModalSignInContent.tsx';
import { formatNumber } from '@/utils';

export const SignInSchema: ZodType<SignInFormData> = z.object({
    msisdn: z.string().refine(val => String(formatNumber(val)).length === 10),
    code: z.string().refine(val => val.length === 6),
    agreement: z.boolean().refine(val => val),
});
